export default class ImportCSVModel {
	public fileDropPickerVisible: boolean;
	public exportButtonVisible: boolean;
	public cancelButtonEnabled: boolean;
	public importButtonEnabled: boolean;
	public spinnerVisible: boolean;
	public importListVisible: boolean;
	public importItems: string[];
	public invalidFileErrrorMessageVisible: boolean;
	public networkErrrorMessageVisible: boolean;
	public unknownErrrorMessageVisible: boolean;
	public downloadCSVButtonEnabled: boolean;
	public constructor() {
		this.fileDropPickerVisible = false;
		this.exportButtonVisible = false;
		this.cancelButtonEnabled = true;
		this.importButtonEnabled = false;
		this.spinnerVisible = false;
		this.importListVisible = false;
		this.invalidFileErrrorMessageVisible = false;
		this.networkErrrorMessageVisible = false;
		this.unknownErrrorMessageVisible = false;
		this.downloadCSVButtonEnabled = false;
		this.importItems = [];
	}
}
